export class Sticky {
  constructor(elemHeader, elemContent, stickyClass = 'sticky-header', stickyBeforeClass = 'sticky-header-before') {
    this.stickyClass = stickyClass;
    this.stickyBeforeClass = stickyBeforeClass;
    this.header = document.getElementsByClassName(elemHeader)[0];
    this.content = document.getElementsByClassName(elemContent)[0];

    this.init();
  }

  init() {
    if(this.header && this.content) {
      document.addEventListener("DOMContentLoaded", function(){
        this.resize();
        this.scroll();
        this.events();
      }.bind(this));
    }
  }

  resize() {
    this.sticky_after = this.content.offsetTop;
    this.sticky_before = this.header.scrollHeight;
  }

  scroll() {
    let scrollY = window.pageYOffset;
  
    if(scrollY > this.sticky_after) {
      document.body.classList.add(this.stickyClass);
      document.body.classList.remove(this.stickyBeforeClass);
    } else {
      document.body.classList.remove(this.stickyClass);

      if(scrollY > this.sticky_before) {
        document.body.classList.add(this.stickyBeforeClass);
      } else {
        document.body.classList.remove(this.stickyBeforeClass);
      }
    }

  }

  events() {
    window.addEventListener('scroll', _.throttle(function() {
      this.scroll();
    }, 50).bind(this));

    window.addEventListener('resize', _.throttle(function() {
      this.resize();
    }, 50).bind(this));
  }
}